"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createCall", {
  enumerable: true,
  get: function get() {
    return _createCall["default"];
  }
});

var _createCall = _interopRequireDefault(require("./createCall"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }